import type { AssessmentResponse, PlanningInfoResponse } from '@/lib/api/assessment';

export type AssessmentPlanningCacheEntry = {
  assessment?: AssessmentResponse;
  planningInfo?: PlanningInfoResponse;
  cachedAt: number;
};

const cache = new Map<string, AssessmentPlanningCacheEntry>();

export function peekAssessmentPlanningCache(
  sessionId: string,
): AssessmentPlanningCacheEntry | null {
  return cache.get(sessionId) ?? null;
}

export function isAssessmentPlanningCacheComplete(sessionId: string): boolean {
  const entry = cache.get(sessionId);
  return Boolean(entry?.assessment && entry?.planningInfo);
}

export function mergeAssessmentPlanningCache(
  sessionId: string,
  partial: {
    assessment?: AssessmentResponse;
    planningInfo?: PlanningInfoResponse;
  },
): void {
  const prev = cache.get(sessionId);
  cache.set(sessionId, {
    assessment: partial.assessment ?? prev?.assessment,
    planningInfo: partial.planningInfo ?? prev?.planningInfo,
    cachedAt: Date.now(),
  });
}

export function clearAssessmentPlanningCache(sessionId?: string): void {
  if (sessionId) {
    cache.delete(sessionId);
    return;
  }
  cache.clear();
}
